export default "__VITE_ASSET__BQbuIYys__"